<template>
  <div id="ChargeSheet">
          <div class="row">
            <div class="col-12">
              <MdTitle v-bind:Text="$t('ChargeSheet.ChargeSheet')"/>
            </div>
          </div> 
          
          <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
            <div class="input-group">
              <input 
                type="text" 
                class="form-control"
                v-model="SearchCriteria"
                @keyup.enter="GetChargeSheetFilteredList()"
              >
              <div class="input-group-append">
                <MdButton 
                  v-bind:Name="'btnsearchinput'"
                  v-bind:VariantProp="'btn btn-sm search-attached'"
                  v-bind:IconClass="'mdi mdi-magnify'"
                >
                </MdButton>
              </div>
            </div>
          </div>

          <b-row>
            <b-col md="3" lg="3" sm="12">
								<MdEdit 
									v-bind:Label="$t('Shared.datefrom')"
									v-bind:TypeProp="'date'" 
									v-bind:Name="'DateFrom'"
									v-model="DateFrom"
									v-bind:Min="'1900-01-01'"
									v-bind:Max="'2200-12-31'"
									v-on:change="DateFromChange($event)"
									v-bind:Id="'input_date_from'"
									v-bind:OnPressEnter="GetChargeSheetFilteredList">                                     
              </MdEdit>
						</b-col>
						<b-col md="3" lg="3" sm="12">
								<MdEdit 
									v-bind:Label="$t('Shared.dateTo')"
									v-bind:TypeProp="'date'" 
									v-bind:Name="'DateTo'"
									v-model="DateTo"
									v-bind:Min="'1900-01-01'"
									v-bind:Max="'2200-12-31'"
									v-on:change="DateToChange($event)"
									v-bind:Id="'input_date_to'"
									v-bind:OnPressEnter="GetChargeSheetFilteredList">                                     
								</MdEdit>
						</b-col>
            <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Program',2)"
              v-bind:Options="ProgramOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:AllowEmpty="true"
              v-bind:Multiple="false"
              v-bind:Model="ProgramModel"  
              :Input="ChangeProgram"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.Status')"
              v-bind:Options="StatusOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:AllowEmpty="true"
              v-bind:Multiple="false"
              v-bind:Model="StatusModel"  
              :Input="ChangeStatus"/>
          </b-col> 
        </b-row>
        <b-row>              
              <b-col lg="12" md="12" sm="12">
                  <div class="text-center text-md-right mt-3">
											<button 												
												type="button"
                        v-on:click="GetChargeSheetFilteredList"
												class="btn btn-primary btn-login mx-2 pull-right"												
												id="btnsearchinput">
												{{ $t('Shared.Search') }}
											</button>
										</div>
                </b-col>         
          </b-row>


      <b-row>
          <b-col md="12">              
            <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/> 
              <MdTable 
                v-bind:fields="fields"
                v-bind:items="items"
                v-bind:totalRows="totalRows"
                v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                v-bind:currentPage="currentPage"
                v-bind:perPage="perPage"
                v-bind:pageOptions="pageOptions"
                v-bind:refTable="'tablePatientpostPayment'"                      
                :onRowSelected="onRowSelected"
                :onFiltered="onFiltered"
                :pageChanged="pageChanged"
                :perPageFunction="PerPageFunction"
                :viewIconEvent="handleViewEvent">
              </MdTable>
          </b-col>
      </b-row>


  </div>
</template>

<script>
    import ChargeSheetService from '@/services/chargesheet.service'
    import ProgramService from '@/services/programs.services'
    import ShowMessage from '@/components/messages/ShowMessage.js';
    import DBFunctions from '@/common/DBFunctions.js';
    import Utils from "@/common/utils";

    export default {
        mixins: [ShowMessage, DBFunctions],
        name: 'ChargeSheet',
        data(){
        return {
          items:[],
          Header:{},
          DateFrom:null,
          DateTo:null,
          SearchCriteria:"",
          ShowMessageIsEmpty:false,
          pageOptions: [5,10,20,30,40,50],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
          OptionsRightMenu:{
              visible:false,
              ItemsList:[],
              btnvisible:false,
              itemdisabled: false,            
              favButtonAtion:false          
            },

           fields: [           
            { key: 'patientcode', sortable: true, label: 'Patient Code', class: 'text-rigth' },
            { key: 'patientName', sortable: true, label: 'Patient Name', class: 'text-rigth' },
            { key: 'admitdate', sortable: true, label: 'Admit Date', class: 'text-rigth' },
            { key: 'admittime', sortable: true, label: 'Admit Time', class: 'text-rigth' },
            { key: 'dischargedate', sortable: true, label: 'Discharge Date', class: 'text-rigth' },
            { key: 'dischargetime', sortable: true, label: 'Discharge Time', class: 'text-rigth' },
            { key: 'roomno', sortable: true, label: 'Room', class: 'text-rigth' },
            { key: 'admissionsource', sortable: true, label: 'SRC', class: 'text-rigth' },            
            { key: 'admissiontype', sortable: true, label: 'Type', class: 'text-rigth' },            
            { key: 'programcode', sortable: true, label: 'Program', class: 'text-rigth' },
            { key: 'minServiceDate', sortable: true, label: 'Service Date From', class: 'text-rigth' },
            { key: 'maxServiceDate', sortable: true, label: 'Service Date To', class: 'text-rigth' },
            { key: 'company', sortable: true, label: 'Company', class: 'text-rigth' },
          ],
          showMessageIsEmpty: false,
          ProgramOptions : [],
          ProgramModel :  null,
          StatusOptions:[
            {name:"All", code:"All"},
            {name:"Active",code:"Active"},
            {name:"Unbilled",code:"Unbilled"}
          ],
          StatusModel: {name:"Unbilled",code:"Unbilled"}
        };
      },
        methods: {

          handleViewEvent(item) {
            this.$router.push({
              name: "chargesheetdetail",
              params: { id:  item.patientcode.trim() },
            });
          },

          async getPrograms(){
            let params = {'ProgramType': 'Inpatient'} 
            await ProgramService.getAll(params)
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0){
                  this.ProgramOptions = response.data;
                }               
              })
              .catch((error) => {
              this.showResponseErrorMessage(error);
              });  
          },

          ChangeProgram(item) {   
            this.ProgramModel = item;
            this.GetChargeSheetFilteredList();
          },

          ChangeStatus(item) {   
            this.StatusModel = item;
            this.GetChargeSheetFilteredList();
          },

          pageChanged(page){            
            this.currentPage = page;    
            this.GetChargeSheetFilteredList();   
          },

          PerPageFunction(perpage){
            this.perPage = perpage;              
            this.currentPage = 1;   
            this.GetChargeSheetFilteredList();       
          },

          onRowSelected(){

          },

          onFiltered(){

          },

          DateFromChange(){

          },

          DateToChange(){

          },


          async GetChargeSheetFilteredList() {
                  this.$emit('load', true)
                  let params = {
                    "SearchCriteria":this.SearchCriteria,
                    "PageSize":  this.perPage,
                    "PageNumber" : this.currentPage,
                    "DateFrom": Utils.formatterToISO(this.DateFrom),
                    "DateTo": Utils.formatterToISO(this.DateTo),
                    "ProgramCode": this.ProgramModel && this.ProgramModel.code ? this.ProgramModel.code : null,
                    "Status": this.StatusModel && this.StatusModel.code ? this.StatusModel.code : null,                  
                  }                
                  await ChargeSheetService.getAll(params)
                  
                 .then((response) => {
                    if(response.status == '200'){
                        this.items = response.data; 
                        
                        let headerString = response.headers["x-pagination"];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;    

                        this.items.forEach(element => {  
                          element.admitdate = element.admitdate ? Utils.formatterDateToString(element.admitdate) : null; 
                          element.dischargedate = element.dischargedate && element.dischargedate != '0001-01-01T00:00:00'  ? Utils.formatterDateToString(element.dischargedate) : null; 
                          element.maxServiceDate = element.maxServiceDate  && element.maxServiceDate != '0001-01-01T00:00:00' ? Utils.formatterDateToString(element.maxServiceDate) : null;
                          element.minServiceDate = element.minServiceDate  && element.minServiceDate != '0001-01-01T00:00:00' ? Utils.formatterDateToString(element.minServiceDate) : null;

                          element.admittime = element.admittime ? Utils.formatTime(element.admittime) : null;
                          element.dischargetime = element.dischargetime && element.dischargetime != '0001-01-01T00:00:00' ? Utils.formatTime(element.dischargetime) : null;
                         })

                      }               
                      this.$emit('load', false);
                  }).catch(error => {
                    this.$emit('load', false);
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        } 
      },
      created() {
      },

      async mounted(){
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
          case 'L0R1':
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
          case 'L1R0':
          case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
          default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        await this.getPrograms()
        await this.GetChargeSheetFilteredList();
      }
    };
</script>
